import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { FC } from 'react';

interface IPagination {
  pageIndex: number,
  totalPages: number,
  setPageIndex:React.Dispatch<React.SetStateAction<number>>;
  disabled?: boolean;
}

export const Pagination:FC<IPagination> = ({ pageIndex, totalPages, setPageIndex, disabled }) => {
  return (
    <div className={`flex justify-center mt-4 gap-2  items-center ${
      disabled ? 'opacity-50 pointer-events-none' : ''
    }`}>
      <ChevronLeftIcon
        className="w-5 h-5 text-white cursor-pointer stroke-3"
        onClick={() => setPageIndex((prev) => Math.max(prev - 1, 0))}
      />
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index}
          className={`w-8 h-8  border rounded-sm cursor-pointer font-jostSemiBold font-semibold text-base leading-5  ${
            pageIndex === index
              ? 'bg-[rgba(189,224,245,1)] border-[rgba(189,224,245,1)] text-[rgba(31,43,64,1)]'
              : 'border-[rgba(31,43,64,1)] bg-transparent  text-white'
          }`}
          onClick={() => setPageIndex(index)}>
          {index + 1}
        </button>
      ))}
      <ChevronRightIcon className='w-5 h-5 stroke-3 cursor-pointer text-white'
        onClick={() =>
          setPageIndex((prev) => (prev + 1 < totalPages ? prev + 1 : prev))
        }
      />
    </div>
  );
};
